{
  "version": 1,
  "asset_id": "5c8d9c02-6296-4d57-b886-570a5ae6a727",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/5c8d9c02-6296-4d57-b886-570a5ae6a727/sleeve-gastrectomy-es-v2-1200.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/5c8d9c02-6296-4d57-b886-570a5ae6a727/sleeve-gastrectomy-es-v2-1200.webp",
  "original_filename": "sleeve-gastrectomy-es-v2-1200.webp",
  "size": 77454,
  "content_type": "image/webp",
  "created_at": "2026-09-25T13:06:30Z"
}
